import { useState } from 'react';

import {
  SmartApplyApiError,
  authPasswordResetConfirm,
} from '../lib/api-client.js';
import { useAuth } from '../lib/auth-context.js';
import { useRoute } from '../lib/route.js';
import { AuthLayout } from '../components/auth/AuthLayout.js';
import { PasswordInput } from '../components/auth/PasswordInput.js';
import { PasswordStrength } from '../components/auth/PasswordStrength.js';

export function ResetPasswordRoute() {
  const { refresh } = useAuth();
  const { query, navigate } = useRoute();
  const token = query.token ?? '';

  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await authPasswordResetConfirm({ token, newPassword: password });
      await refresh();
      navigate('/');
    } catch (err) {
      setError(err instanceof SmartApplyApiError ? err.message : 'Falha ao redefinir.');
    } finally {
      setLoading(false);
    }
  }

  if (!token) {
    return (
      <AuthLayout title="Token ausente" badge="recovery">
        <p className="font-sans text-base text-[var(--ink-primary)]">
          O link de redefinição precisa de um token. Use o link enviado por e-mail.
        </p>
        <a
          href="#/forgot-password"
          className="mt-6 inline-block font-sans text-sm text-[var(--accent-saffron)] underline underline-offset-4"
        >
          Solicitar novo link →
        </a>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout
      title="Nova senha"
      subtitle="Escolha uma senha diferente da anterior. Após confirmar, todas as suas sessões existentes serão revogadas (segurança)."
      badge="recovery"
    >
      <form onSubmit={handleSubmit} className="card-paper rounded-sm px-7 py-7" style={{ borderLeft: '3px solid var(--accent-saffron)' }}>
        <div className="space-y-5">
          <PasswordInput
            id="password"
            label="Nova senha"
            autoComplete="new-password"
            required
            minLength={12}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            hint="Mínimo 12 chars com 3 das 4 classes."
          />
          {password && <PasswordStrength value={password} />}

          {error && (
            <div className="rounded-sm border border-[var(--accent-crimson-border)] bg-[var(--accent-crimson-bg)] px-4 py-2.5">
              <p className="font-sans text-sm text-[var(--accent-crimson)]">{error}</p>
            </div>
          )}

          <button
            type="submit"
            disabled={loading || !password}
            className="rounded-sm bg-[var(--ink-primary)] px-5 py-2 font-sans text-sm text-[var(--bg-paper)] transition-opacity hover:opacity-90 disabled:opacity-40"
          >
            {loading ? 'Salvando...' : 'Redefinir senha'}
          </button>
        </div>
      </form>
    </AuthLayout>
  );
}
